import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/es';
import { getFoods, saveFood } from '../resources';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Select from 'react-select';
import SingleFood from './SingleFood';

moment.locale('es');

const PatientFood = () => {
    const MySwal = withReactContent(Swal);

    const [data, setData] = useState([]);
    const [currentDay, setCurrentDay] = useState({
        day: '',
        title: '',
        value: '',
        breakfast: null,
        breakfast_place_to_eat: null,
        breakfast_comment: null,

        lunch: null,
        lunch_place_to_eat: null,
        lunch_comment: null,

        dinner: null,
        dinner_place_to_eat: null,
        dinner_comment: null,

        tea: null,
        tea_place_to_eat: null,
        tea_comment: null,

        collation: null,
        collation_place_to_eat: null,
        collation_comment: null,

        reference_food_id: null,
        reference_id: null,
    });

    // Subs por categoría: 1 desayuno, 2 comida, 3 cena, 4 té, 5 colación
    const [subsByCat, setSubsByCat] = useState({
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
    });

    // Cargar info desde el backend
    useEffect(() => {
        const gFood = async () => {
            const response = await getFoods();
            if (response.success) {
                const daysWithFormattedTitles = response.days.map(day => ({
                    ...day,
                    title: moment(day.value, 'YYYY-MM-DD').format('dddd D'),
                }));
                setData({ ...response, days: daysWithFormattedTitles });
            }
        };
        gFood();
    }, []);

    // Día actual
    useEffect(() => {
        if (data.days && data.days.length > 0) {
            if (currentDay.value === '') {
                setCurrentDay(data.days[0]);
            } else {
                const day = data.days.find(d => d.day === currentDay.day);
                if (day) {
                    setCurrentDay(day);
                }
            }
        }
    }, [data]);

    // Construir subs por categoría (desayuno/comida/cena/té/colación)
    useEffect(() => {
        if (data.foods) {
            const byCat = {
                1: [],
                2: [],
                3: [],
                4: [],
                5: [],
            };

            data.foods.forEach(food => {
                if (byCat[food.category]) {
                    byCat[food.category].push(...(food.food_sub || []));
                }
            });

            setSubsByCat(byCat);
        }
    }, [data]);

    // Helpers
    const getTitle = (cat) => {
        switch (cat) {
            case 1: return 'Desayuno';
            case 2: return 'Comida';
            case 3: return 'Cena';
            case 4: return 'Té';
            case 5: return 'Colación';
            default: return '';
        }
    };

    const getFood = (cat) => {
        switch (cat) {
            case 1: return currentDay.breakfast?.title;
            case 2: return currentDay.lunch?.title;
            case 3: return currentDay.dinner?.title;
            case 4: return currentDay.tea?.title;
            case 5: return currentDay.collation?.title;
            default: return '';
        }
    };

    const getFoodSub = (cat) => {
        let currentFoodSub = '';
        switch (cat) {
            case 1:
                currentFoodSub = currentDay.breakfast_sub_food;
                break;
            case 2:
                currentFoodSub = currentDay.lunch_sub_food;
                break;
            case 3:
                currentFoodSub = currentDay.dinner_sub_food;
                break;
            case 4:
                currentFoodSub = currentDay.tea_sub_food;
                break;
            case 5:
                currentFoodSub = currentDay.collation_sub_food;
                break;
        }
        return currentFoodSub || '';
    };

    const showModal = (e, cat) => {
        e.preventDefault();

        let currentMeal = '';
        const title = getTitle(cat);
        const foodSelectedTitle = getFood(cat);

        // Opciones de sub-alimento según categoría
        const foodSubs = subsByCat[cat] || [];

        const options = foodSubs.length
            ? foodSubs.map(sub => ({
                label: sub.name,
                value: sub.id,
            }))
            : [];

        // Lugar por defecto
        let currentPlaceToEat = 'comedor';
        const optionsWhereToEat = [
            { value: 'comedor', label: 'Comedor' },
            { value: 'habitación', label: 'Habitación' },
        ];

        switch (cat) {
            case 1:
                currentPlaceToEat = currentDay.breakfast_place_to_eat || 'comedor';
                break;
            case 2:
                currentPlaceToEat = currentDay.lunch_place_to_eat || 'comedor';
                break;
            case 3:
                currentPlaceToEat = currentDay.dinner_place_to_eat || 'comedor';
                break;
            case 4:
                currentPlaceToEat = currentDay.tea_place_to_eat || 'comedor';
                break;
            case 5:
                currentPlaceToEat = currentDay.collation_place_to_eat || 'comedor';
                break;
        }

        // Default seleccionado
        const currentSubName = getFoodSub(cat);
        const defaultFoodSub = currentSubName
            ? foodSubs.find(food => food.name === currentSubName) || null
            : null;

        MySwal.fire({
            width: 600,
            padding: "0px",
            customClass: {
                popup: 'no-padding-sweet add-item',
            },
            confirmButtonText: 'Editar',
            showCloseButton: true,
            preConfirm: () => {
                if (!currentMeal) {
                    alert('Selecciona una opción');
                    return false;
                }
            },
            html: (
                <>
                    <div className="sweetalert-header">
                        <div className="terapia">Seleccionar {title}</div>
                    </div>
                    <div style={{ margin: 15 }}>
                        <strong>{title}</strong>
                        <label className='subtitle-line'>{foodSelectedTitle}</label>
                    </div>
                    <div style={{ margin: 15 }}>
                        <strong>Alimento a consumir</strong>
                        <Select
                            menuPlacement='auto'
                            menuPosition="fixed"
                            onChange={(opt) => { currentMeal = opt.value; }}
                            options={options}
                            defaultValue={
                                defaultFoodSub
                                    ? { label: defaultFoodSub.name, value: defaultFoodSub.id }
                                    : null
                            }
                        />
                    </div>
                    <div style={{ margin: 15 }}>
                        <strong>¿Dónde deseas tomar tus alimentos?</strong>
                        <Select
                            menuPlacement='auto'
                            menuPosition="fixed"
                            defaultValue={optionsWhereToEat.find(option => option.value === currentPlaceToEat)}
                            onChange={(opt) => { currentPlaceToEat = opt.value; }}
                            options={optionsWhereToEat}
                        />
                    </div>
                </>
            )
        }).then(async (result) => {
            if (result.isConfirmed) {
                await saveFood(
                    currentMeal,
                    currentPlaceToEat,
                    cat,
                    currentDay.day,
                    currentDay.residence_id,
                    currentDay.value
                );

                const response = await getFoods();
                if (response.success) {
                    const daysWithFormattedTitles = response.days.map(day => ({
                        ...day,
                        title: moment(day.value, 'YYYY-MM-DD').format('dddd D'),
                    }));
                    setData({ ...response, days: daysWithFormattedTitles });
                }
            }
        });
    };

    const changeDay = (e, day) => {
        e.preventDefault();
        setCurrentDay(day);
    };

    return (
        <>
            <div className="text-center col-12">
                <div className="nav-terapias">
                    <ul>
                        {data.days && data.days.map(d => (
                            <li
                                key={`day-${d.day}`}
                                className={`${(d.day === currentDay.day) ? 'active' : ''}`}
                            >
                                <a href="#" onClick={(e) => changeDay(e, d)}>{d.title}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="col-12 bg-gray" style={{ width: '100%' }}>
                <div className='row'>
                    <div className='col-10 offset-1'>
                        <div className='row'>
                            {/* Té */}
                            <SingleFood
                                title="Té"
                                currentDay={currentDay}
                                food={currentDay.tea}
                                foodSub={getFoodSub(4)}
                                showModal={showModal}
                                cat={4}
                                doctorComment={currentDay.tea_comment}
                            />

                            {/* Desayuno */}
                            <SingleFood
                                title="Desayuno"
                                currentDay={currentDay}
                                food={currentDay.breakfast}
                                foodSub={getFoodSub(1)}
                                showModal={showModal}
                                cat={1}
                                doctorComment={currentDay.breakfast_comment}
                            />

                            {/* Comida */}
                            <SingleFood
                                title="Comida"
                                currentDay={currentDay}
                                food={currentDay.lunch}
                                foodSub={getFoodSub(2)}
                                showModal={showModal}
                                cat={2}
                                doctorComment={currentDay.lunch_comment}
                            />

                            {/* Cena */}
                            <SingleFood
                                title="Cena"
                                currentDay={currentDay}
                                food={currentDay.dinner}
                                foodSub={getFoodSub(3)}
                                showModal={showModal}
                                cat={3}
                                doctorComment={currentDay.dinner_comment}
                            />

                            {/* Colación */}
                            <SingleFood
                                title="Colación"
                                currentDay={currentDay}
                                food={currentDay.collation}
                                foodSub={getFoodSub(5)}
                                showModal={showModal}
                                cat={5}
                                doctorComment={currentDay.collation_comment}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PatientFood;

if (document.getElementById('patient-foods')) {
    ReactDOM.render(<PatientFood />, document.getElementById('patient-foods'));
}
